import React from 'react';

import { FormTextField, FormTextFieldProps, TextFieldProps } from '../form-text-field';

type Props = Omit<FormTextFieldProps, 'validationOptions' | 'type'> & TextFieldProps;

export const FormLine2Field: React.FC<Props> = ({
  autoComplete = 'address-line2',
  label = 'Address Line 2 (Optional)',
  required,
  ...props
}) => {
  return (
    <FormTextField
      {...props}
      type="text"
      label={label}
      autoComplete={autoComplete}
      validationOptions={{ required, maxLength: 200 }}
      data-testid="formAddressLine2Input"
    />
  );
};
